"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import { useLocale, useTranslations } from "next-intl";
import Button from "../../components/common/Button/Button";
import Image from "next/image";

type Props = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function GlobalError({ error }: Props) {
  const t = useTranslations();

  useEffect(() => {
    Sentry.captureException(error, {
      tags: { digest: (error as any).digest },
      extra: {
        note: "The error comes from the GlobalError command.",
      },
    });
  }, [error]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="p-4">
        <div className="flex justify-center items-center">
          <div className="relative w-fit">
            <Image
              className="w-40 h-40"
              src="/assets/v2/icons/gatepay-logo.svg"
              alt="booking success"
              width={160}
              height={160}
            />
          </div>
        </div>
        <div className="text-center mt-8 flex flex-col font-switzer text-xl">
          <h1 className="font-switzer font-bold text-[28px]">
            {t("Other.oopsSomethingWentWrong")}
          </h1>
          <p className="mt-4 font-normal font-switzer text-xl">
            {t("Other.tryRefreshingThePage")}
          </p>
          <div className="flex justify-center mx-auto mt-6 mb-2">
            <Button onClick={() => location.reload()}>
              {t("Other.refreshThePage")}
            </Button>
          </div>
          {error?.digest && (
            <p className="text-xs text-gray-400">
              {t("Other.codeNumber", { code: error.digest })}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
